import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";

import { AuthService } from ".";
import { environment } from "../../../environments/environment";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const authService = inject(AuthService);

    const role = getAuthRole(request.url);

    if (!role) {
        return next(request);
    }

    const accessToken = authService.getAccessToken(role);

    if (!accessToken) {
        return next(request);
    }

    const authenticatedRequest = request.clone({
        setHeaders: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return next(authenticatedRequest);
};

function getAuthRole(url: string): "user" | "admin" | null {
    const apiBaseUrl = environment.apiUrlBasePath;

    const path = url.startsWith(apiBaseUrl) ? url.slice(apiBaseUrl.length) : url;

    if (path.startsWith("/admin/") || path.startsWith("/auth/admin/")) {
        return "admin";
    }

    if (path.startsWith("/")) {
        return "user";
    }

    return null;
}
